import { createAsyncThunk } from "@reduxjs/toolkit"
import {
  del,
  formDataPost,
  formDataPut,
  get,
  patch,
  post,
  put,
} from "helpers/api_helper"
import {
  ADD_COUNTRY,
  DELETE_COUNTRY,
  GET_ALL_COUNTRIES,
  GET_ALL_COUNTRY_LIST,
  GET_COUNTRY_DETAILS,
  UPDATE_COUNTRY,
  UPDATE_COUNTRY_STATUS,
  UPDATE_TENANT_COUNTRY_TAX_SHIPMENT,
} from "helpers/url_helper"

export const getAllCountries = createAsyncThunk(
  GET_ALL_COUNTRIES,
  async payload => {
    const response = await post(GET_ALL_COUNTRIES, payload)
    return response
  }
)

export const updateCountryStatus = createAsyncThunk(
  UPDATE_COUNTRY_STATUS,
  async payload => {
    const response = await patch(UPDATE_COUNTRY_STATUS, payload)
    return response
  }
)

export const addCountry = createAsyncThunk(ADD_COUNTRY, async payload => {
  const response = await post(ADD_COUNTRY, payload)
  return response
})

export const getCountryDetails = createAsyncThunk(
  GET_COUNTRY_DETAILS,
  async payload => {
    const response = await post(GET_COUNTRY_DETAILS, payload)
    return response
  }
)

export const updateCountry = createAsyncThunk(UPDATE_COUNTRY, async payload => {
  const response = await put(UPDATE_COUNTRY, payload)
  return response
})

export const updateTenantCountryTaxShipment = createAsyncThunk(
  UPDATE_TENANT_COUNTRY_TAX_SHIPMENT,
  async payload => {
    const response = await put(UPDATE_TENANT_COUNTRY_TAX_SHIPMENT, payload)
    return response
  }
)

export const deleteCountry = createAsyncThunk(DELETE_COUNTRY, async payload => {
  const req = { id: payload.id, status: payload.status }
  const response = await del(`${DELETE_COUNTRY}/${payload.id}`)
  return response
})

export const getCountryList = createAsyncThunk(
  GET_ALL_COUNTRY_LIST,
  async payload => {
    const response = await get(GET_ALL_COUNTRY_LIST, payload)
    return response
  }
)
